module.exports = __webpack_public_path__ + "media/images/e-kvitok/clock_white-7dc54939c848c4b4f32c77c317a8b5c4.svg";